// DatePicker localization imports
import { registerLocale } from 'react-datepicker';
import el from 'date-fns/locale/el';
import cy from 'date-fns/locale/cy';
import ie from 'date-fns/locale/en-IE';
import { LANGUAGE_CODES } from 'Douleutaras/constants/system';

// DatePicker localization registration
registerLocale(LANGUAGE_CODES.EL, el);
registerLocale(LANGUAGE_CODES.EL_CY, cy);
registerLocale(LANGUAGE_CODES.EN_IE, ie);
